import { Form } from 'antd';
import Content from 'layouts/Content';
import { memo, useCallback, useMemo } from 'react';

import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import { PageInfo } from 'interfaces/TeamSale/TeamSale';
import formatNumber, {
  DateFormatOption,
  formatDate,
} from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface Iprops {
  page: {
    pageNum: number;
    pageSize: number;
  };
  data: {
    pageInfo: PageInfo;
    items: any[];
  };
  loading?: boolean;
}

export const TableGoldPriceManagement = memo(
  ({ data, page, loading = false }: Iprops) => {
    const [form] = Form.useForm();

    const renderValue = useCallback(
      (
        value: any,
        type?: 'text' | 'date' | 'number',
        optionDate?: DateFormatOption,
      ) => {
        const currentType = type ? type : 'text';

        if (!value) return '-';

        let formatValue;
        if (currentType === 'text') formatValue = value;
        else if (currentType === 'date')
          formatValue = formatDate(value, optionDate);
        else if (currentType === 'number') formatValue = formatNumber(value);

        return formatValue || '-';
      },
      [],
    );

    const columns: ColumnsTypeCustom = useMemo(
      () =>
        [
          {
            title: 'STT',
            width: 50,
            className: 'text-end align-top',
            align: 'center',
            render: (_, __, index: number) =>
              index + 1 + page.pageSize * (page.pageNum - 1),
          },
          {
            width: 170,
            title: 'Loại vàng',
            dataIndex: 'typeGold',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          {
            width: 100,
            align: 'right',
            title: 'Giá mua',
            dataIndex: 'buyPrice',
            className: 'text-start align-top',
            render: (value) => renderValue(value, 'number'),
          },
          {
            width: 100,
            type: 'number',
            align: 'right',
            title: 'Giá bán',
            dataIndex: 'salePrice',
            className: 'text-end align-top',
            render: (value) => renderValue(value, 'number'),
          },
          {
            width: 100,
            align: 'right',
            type: 'number',
            title: 'Giá gram',
            dataIndex: 'amountGram',
            className: 'text-end align-top',
            render: (value) => renderValue(value, 'number'),
          },
          // {
          //   width: 150,
          //   title: 'MCgroup',
          //   dataIndex: 'mcGroup',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          // {
          //   //
          //   width: 150,
          //   dataIndex: 'type',
          //   title: 'Đơn vị giá',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          {
            width: 150,
            dataIndex: 'unit',
            title: 'Đơn vị tính',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          // {
          //   width: 150,
          //   title: 'Công ty',
          //   dataIndex: 'plant',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          {
            width: 150,
            title: 'Kênh',
            dataIndex: 'channel',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          {
            width: 150,
            title: 'Mã',
            dataIndex: 'conditionId',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          {
            width: 150,
            title: 'Loại',
            dataIndex: 'conditionType',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          // {
          //   width: 150,
          //   dataIndex: 'district',
          //   title: 'Khu vực',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          {
            width: 150,
            dataIndex: 'customer',
            title: 'Cửa hàng',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
          // {
          //   width: 150,
          //   dataIndex: 'customer',
          //   title: 'Khách hàng',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          // {
          //   width: 150,
          //   dataIndex: 'groupPrice',
          //   title: 'Nhóm khách hàng',
          //   className: 'text-start align-top',
          //   render: (value) => renderValue(value),
          // },
          {
            width: 160,
            type: 'date',
            title: 'Ngày bắt đầu',
            dataIndex: 'validFromDate',
            className: 'text-start align-top',
            render: (value) => renderValue(value, 'date', 'DD/MM/YYYY'),
          },
          {
            width: 125,
            title: 'Ngày kết thúc',
            dataIndex: 'validtoDate',
            className: 'text-start align-top',
            render: (value) => renderValue(value, 'date', 'DD/MM/YYYY'),
          },
          {
            width: 160,
            type: 'date',
            dataIndex: 'modifyDate',
            title: 'Thời gian cập nhật',
            className: 'text-start align-top',
            render: (value) => renderValue(value, 'date'),
          },
          {
            width: 50,
            title: 'Nguồn',
            dataIndex: 'updateOrigin',
            className: 'text-start align-top',
            render: (value) => renderValue(value),
          },
        ] as ColumnsTypeCustom,
      [page],
    );

    return (
      <Content>
        <Form form={form}>
          <TableComponent
            rowKey={(record: any) => record?.id ?? ''}
            dataSource={data.items}
            columns={columns}
            loading={loading}
            scroll={{ x: 2500 }}
            pagination={{
              current: data?.pageInfo?.currentPage,
              pageSize: data?.pageInfo?.itemsPerPage,
              total: data?.pageInfo?.totalItems,
              onChange: HocChangePagination(),
            }}
          />
        </Form>
      </Content>
    );
  },
);
